<template>
	<div class="EScanCode">
		<div class="ScanInput" v-if="isCount == false">
			<label class="Label">{{Language.LG.ManualEntry[isLanguage]}}</label>
			<input class="uni-input itInput" type="number" v-model="scanInfo.ExpressNum" @input="reTime" :placeholder="Language.LG.ExpressNum[isLanguage]"/>
			<button type="primary" class="confirmBtn" @click="sendExpress">{{Language.LG.Confirm[isLanguage]}}</button>
		</div>
		<div class="scanCont">
			<div class="cont">
				<div class="tit">{{ScanTips}}</div>
				<img class="ScanImg" src="../../../../static/CESite40s/images/bmp_closedoor1.png" alt="">
			</div>
			<div class="scanBtn">
				<span @click="toSubmitList()">{{Language.LG.SubmitList[isLanguage]}}</span>
				<span @click="ContinueDeliver()">{{Language.LG.Continue[isLanguage]}}</span>
			</div>
			<div class="ScanTime" v-if="isCount  && failStatus == false">{{CountTime}}{{Language.LG.CloseScan[isLanguage]}}</div>
		</div>
		
		<!--按钮组-->
		<EConfigBtn :pushBg="'#151c36'" :backUp="backUp" :quit="quit" v-if="isCount == false"></EConfigBtn>
		<!--超时组件-->
		<overTime :callBack="backUp" v-if="isCount == false"></overTime>
		<!--loading -->
		<ELoading v-if="isLoading" :Msg="loadingTips"></ELoading>
	</div>
</template>

<script>
	import overTime from '../assets/overTime.vue'
	import EConfigBtn from '../assets/ConfigBtn.vue'
	import ELoading from '../assets/Loading.vue'
	import { EloginApi } from '../../../../static/CESite40s/js/api.js'
	import { conLog,storage } from '../../../../static/js/utils/utility.js'
	import { hexCharCodeToStr } from '../../../../static/js/utils/util.js'
	import courierOpenDoorTips from '../../../../static/CESite40s/mp3/courier_open_door_tips.mp3'
	import pleaseCloseDoor from '../../../../static/CESite40s/mp3/please_close_door.mp3'
	import { websocketsend } from '../../../../static/js/utils/socket.js'
	var vm
	export default {
		data() {
			return {
				configStorage:null,
				userInfo:null,//用户信息
				boxInfo:'',//选中的箱格大小
				
				isLanguage:0,
				Language:'',
				
				ScanTips:'',//提示语
				
				scanInfo:{
					ExpressNum:'',
				},
				
				//超时
				CountTime:60,
				CountTimeStatus:'',
				isCount:true,
				
				loadingTips:'',
				isLoading:false,//是否显示loading组件
				
				failStatus:false,
			};
		},
		components:{
			overTime,
			EConfigBtn,
			ELoading
		},
		async created(){
			vm = this
			var configStorage = storage.localGetItem('configStorage');
			if(configStorage){
				vm.configStorage = configStorage
			}
			const userInfo = storage.localGetItem('userInfo')
			if(userInfo){
				vm.userInfo = userInfo
			}
			vm.boxInfo = vm.$route.query.boxInfo
			
			var isLanguage = storage.localGetItem('isLanguage');
			if(isLanguage){
				vm.isLanguage = isLanguage
			}
			vm.Language = vm.$Language
			
			vm.$store.state.overTime = 80
			
			vm.ScanTips = vm.$Language.LG.Plscan[vm.isLanguage]
			
			vm.scanCode();//页面进来就开始扫码
			vm.CountDown(vm.CountTime)
		},
		mounted(){
			
		},
		methods:{
			//获取ws消息
			getSkMsg(res){
				conLog('getSkMsg',res)
				let str = res.substring(34,res.length-2)
				let typeNum = res.substring(26,30)
				str = hexCharCodeToStr(str)
				conLog('快递号',str)
				//f500功能码
				if(typeNum == 'f500'){
					vm.scanInfo.ExpressNum = str
					vm.sendExpress()
				}
			},
			//开始扫码
			async scanCode(){
				let data = {
					'cabinet_id':vm.configStorage.deviceId,//设备ID
				}
				const res = await EloginApi.cancelScanCode(data)
				if(res){
					if(res.meta.code==200){
						websocketsend('a5552003121118520000000001f50000010090')
					}else{
						vm.$message({
							message: res.meta.message,
							type: 'error',
							duration:1000
						});
					}
				}
			},
			//取消扫码
			async cancelScanCode(){
				// uni.onSocketClose(function (res) {
				// 	console.log('WebSocket 已关闭！');
				// });
				let data = {
					'cabinet_id':vm.configStorage.deviceId,//设备ID
				}
				const res = await EloginApi.cancelScanCode(data)
				if(res){
					if(res.meta.code==200){

					}else{
						vm.$message({
							message: res.meta.message,
							type: 'error',
							duration:1000
						});
					}
				}
			},
			//投递
			async sendExpress(){
				let data = {
					"box_style": vm.boxInfo,//选择的箱格大小类型
					"cabinet_id": vm.configStorage.deviceId,//设备ID
					"check_appointment": 1,
					"come_from": 3,
					"company_name": vm.configStorage.company_name,//公司名称
					"delivery_type": 1,
					"pay_way": 0,
					"receiver_phone": vm.userInfo.phone_no,//取件人手机号码，要改的，暂时跟快递员同个手机号
					"sender_phone": vm.userInfo.phone_no,//快递员手机号码
					"t_package_no": vm.scanInfo.ExpressNum,//快递单号
					"unconfirmed": 1
				}
				conLog('data',data)
				vm.loadingTips = vm.$Language.LG.ParcelLoading1[vm.isLanguage]+vm.scanInfo.ExpressNum+vm.$Language.LG.ParcelLoading2[vm.isLanguage]
				vm.isLoading = true
				vm.failStatus = true
				vm.CountTime = 40
				const res = await EloginApi.sendExpress(data)
				conLog('投递',res)
				vm.isLoading = false
				if(res){
					if(res.meta.code == 200){
						vm.scanInfo.ExpressNum = ''
						//放入物品后请随手关门(语音)
						var url = courierOpenDoorTips
						var audio = new Audio(url);
						audio.src = url;
						audio.play();
						vm.ScanTips = vm.$Language.LG.sendExpress1[vm.isLanguage] + res.body.box_no + vm.$Language.LG.sendExpress2[vm.isLanguage]
					}else{
						clearTimeout(vm.CountTimeStatus)
						vm.ScanTips = res.meta.message+'('+res.meta.code+')'
					}
				}
			},
			//重置时间
			reTime(){
				vm.$store.state.overTime = 80
			},
			//继续投递
			ContinueDeliver(){
				let that = this
				vm.failStatus = false
				if(vm.CountTime > 40){
					vm.ScanTips = vm.$Language.LG.NoAction[vm.isLanguage]
				}else{
					vm.CountTime = 60
					vm.isCount = true
					vm.ScanTips = vm.$Language.LG.Plscan[vm.isLanguage]
					vm.CountDown(vm.CountTime)
					vm.scanCode();//调用开始扫码
				}
			},
			//点击提交清单入库
			toSubmitList(){
				if(vm.CountTime > 40){
					vm.ScanTips = vm.$Language.LG.NoAction[vm.isLanguage]
				}else{
					// this.loadingTips = this.$Language.LG.ParcelLoading1[this.isLanguage]+this.scanInfo.ExpressNum+this.$Language.LG.ParcelLoading2[this.isLanguage]
					// this.isLoading = true
					setTimeout(function(){
						vm.$router.push({
							path:'/CEsite40s/EWarehousList',
							query:{
								'type': '2'
							}
						})
					},2000)
				}
			},
			
			//返回上一页
			backUp(){
				vm.$router.push({
					path:'/CEsite40s/ESelectBox'
				})
			},
			//退出登录
			quit(){
				vm.$router.push({
					path:'/CEsite40s'
				})
			},
			
			//超时
			CountDown(wait){
				if(wait == 40) {
					vm.CountTime = wait
					clearTimeout(vm.CountTimeStatus)
					vm.isCount = false
					vm.ScanTips = vm.$Language.LG.ScanFailure[vm.isLanguage]
					vm.cancelScanCode();//取消扫码
				} else {
					vm.CountTime = wait
					wait --;
					vm.CountTimeStatus = setTimeout(function() {
						vm.CountDown(wait);
					},1000);
				}
			},
		},
		watch :{
			"$store.state.wsMsg":function(newVal){
				conLog('msg2',newVal)
				vm.getSkMsg(newVal)
			}
		},
		destroyed(){
			clearTimeout(vm.CountTimeStatus)
		},
	}
</script>

<style lang="less">
.EScanCode{
	height: 100vh;
	background: #f2f2f2;
	text-align: center;
	.ScanInput{
		padding: 0.2rem 0;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.36rem;
		.Label{
			background: #151c36;
			color: #fff;
			height: 1rem;
			line-height: 1rem;
			width: 3rem;
			flex-shrink: 0;
			border-top-left-radius: 0.15rem;
			border-bottom-left-radius: 0.15rem;
		}
		.itInput{
			width: 6rem;
			height: 1rem;
			min-height: 1rem;
			line-height: 1rem;
			text-align: left;
			font-size: 0.3rem;
			color: #151c36;
			background: #fff;
			margin-right: 0.2rem;
			padding: 0 0.2rem;
		}
		.confirmBtn{
			height: 1rem;
			line-height: 1rem;
			background-color: #151c36;
			border-radius: 0.15rem;
			padding: 0 0.5rem;
			font-size: 0.36rem;
		}
	}
	.scanCont{
		position: absolute;
		width: 50%;
		left: 50%;
		margin-left: -25%;
		top: 50%;
		margin-top: -3.59rem;
		color: #151c36;
		.ScanTime{
			position: absolute;
			left: 103%;
			top: 50%;
			margin-top: -0.1rem;
			font-size: 0.3rem;
			white-space: nowrap;
		}
		.scanBtn{
			background: #fff;
			box-shadow: 0 0.02rem 0.03rem 0.02rem rgba(0,0,0,.12);
			padding: 0.35rem 0.25rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-radius: 0.1rem;
		}
		.cont{
			background: #fff;
			padding-bottom: 0.3rem;
			box-shadow: 0 0.02rem 0.03rem 0.02rem rgba(0,0,0,.12);
			margin-bottom: 0.1rem;
			border-radius: 0.1rem;
			.tit{
				font-size: 0.4rem;
				color: #31a3dc;
				padding: 0.15rem;
			}
			.ScanImg{
				width: 5.76rem;
				height: 4.31rem;
			}
		}
	}
	.overTime{
		color: #666;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/CEsite40s/ScanCode/ScanCode.vue